import { Box, FormControl } from '@mui/material';
import styled from 'styled-components';

export const StyledBox = styled(Box)`
  display: flex;
  justify-content: right;
`;

export const StyledFormControl = styled(FormControl)`
  min-width: 20%;
`;
